<template>
  <div class="component">
    <b-container fluid class="pb-20 pt-30">
      <b-row>
        <b-col cols="6" md="4">
          <DonutChartWidget :data="queriesData" :titleColor="queriesData[0].color" title="Queries" info="The number of queries created by research team" />
        </b-col>
        <b-col cols="6" md="4">
          <DonutChartWidget :data="verificationData" :titleColor="verificationData[0].color" title="Verification" info="The number of forms verified by the research team" />
        </b-col>
        <b-col cols="6" md="4">
          <DonutChartWidget :data="approvalData" :titleColor="approvalData[0].color" title="Approval" info="The number of forms approved by the Principal Investigator(s)" />
        </b-col>
      </b-row>
    </b-container>
    <br />

    <table-component :showTable="false" showTotal showEmpty :printTotalFormatter="printTotalFormatter" tableWrapperComponent="b-card" filterLabelMessage="" :perPage="perPage" :totalItems="totalForms" showFilter :filterOptions="filterOptions" :studyData="studyData" :items="getQueries" :fields="tableFields" v-model="tableValues" @onFilterUpdate="onFilterUpdate" />

    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 col-xs-12 pb-20 pl-0 pr-0">
        <div class="table-column">
          <div class="wrapper position-relative card side-margings">
            <table class="table pb-60 mb-0 table-responsive data-dashboard">
              <thead class="table-border fs-12">
                <tr>
                  <th v-if="canPiAccess || canCallCenterAccess" class="heading-color heading-label w-150 border-0">
                    <span class="d-flex align-center cursor_pointer disable-text-selection" @click="sortData('email')">
                      Email Address
                      <span class="table-header-align ml-5 d-flex flex-column">
                        <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags == 'email' ? 'link-color' : '']" />
                        <i class="fa fa-angle-down" aria-hidden="true" :class="[headersDscSortFlags == 'email' ? 'link-color' : '']" />
                      </span>
                    </span>
                  </th>
                  <th class="heading-color heading-label border-0 w-190">
                    <span class="d-flex align-center cursor_pointer disable-text-selection" @click="sortData('participantId')">
                      PID/THREAD ID
                      <span class="table-header-align ml-5 d-flex flex-column">
                        <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags == 'participantId' ? 'link-color' : '']" />
                        <i class="fa fa-angle-down" aria-hidden="true" :class="[headersDscSortFlags == 'participantId' ? 'link-color' : '']" />
                      </span>
                    </span>
                  </th>
                  <th class="heading-color heading-label border-0 w-84">
                    <span class="d-flex align-center cursor_pointer disable-text-selection" @click="sortData('siteId')">
                      Site ID
                      <span class="table-header-align ml-5 d-flex flex-column">
                        <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags == 'siteId' ? 'link-color' : '']" />
                        <i class="fa fa-angle-down" aria-hidden="true" :class="[headersDscSortFlags == 'siteId' ? 'link-color' : '']" />
                      </span>
                    </span>
                  </th>
                  <th class="heading-color heading-label border-0 w-144">
                    <span class="d-flex align-center cursor_pointer disable-text-selection" @click="sortData('country')">
                      Country
                      <span class="table-header-align ml-5 d-flex flex-column">
                        <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags == 'country' ? 'link-color' : '']" />
                        <i class="fa fa-angle-down" aria-hidden="true" :class="[headersDscSortFlags == 'country' ? 'link-color' : '']" />
                      </span>
                    </span>
                  </th>
                  <th class="heading-color heading-label border-0 w-224">
                    <span class="d-flex align-center cursor_pointer disable-text-selection" @click="sortData('formOrUnscheduledName')">
                      Form/Activity Name
                      <span class="table-header-align ml-5 d-flex flex-column">
                        <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags == 'formOrUnscheduledName' ? 'link-color' : '']" />
                        <i class="fa fa-angle-down" aria-hidden="true" :class="[headersDscSortFlags == 'formOrUnscheduledName' ? 'link-color' : '']" />
                      </span>
                    </span>
                  </th>
                  <th class="heading-color heading-label border-0 w-190">
                    <span class="d-flex align-center cursor_pointer disable-text-selection" @click="sortData('approvedDate')">
                      Approved On
                      <span class="table-header-align ml-5 d-flex flex-column">
                        <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags == 'approvedDate' ? 'link-color' : '']" />

                        <i class="fa fa-angle-down" aria-hidden="true" :class="[headersDscSortFlags == 'approvedDate' ? 'link-color' : '']" />
                      </span>
                    </span>
                  </th>
                  <th class="heading-color heading-label pl-5 border-0 w-190">
                    <span class="d-flex align-center cursor_pointer disable-text-selection" @click="sortData('verifiedDate')">
                      Verified On
                      <span class="table-header-align ml-5 d-flex flex-column">
                        <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags == 'verifiedDate' ? 'link-color' : '']" />

                        <i class="fa fa-angle-down" aria-hidden="true" :class="[headersDscSortFlags == 'verifiedDate' ? 'link-color' : '']" />
                      </span>
                    </span>
                  </th>
                  <th class="heading-color heading-label border-0 w-190">
                    <span class="d-flex align-center cursor_pointer disable-text-selection" @click="sortData('signoffDate')">
                      Signed Off On
                      <span class="table-header-align ml-5 d-flex flex-column">
                        <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags == 'signoffDate' ? 'link-color' : '']" />
                        <i class="fa fa-angle-down" aria-hidden="true" :class="[headersDscSortFlags == 'signoffDate' ? 'link-color' : '']" />
                      </span>
                    </span>
                  </th>
                  <th class="heading-color heading-label border-0 w-190">
                    <span class="d-flex align-center cursor_pointer disable-text-selection" @click="sortData('reviewedDate')">
                      Reviewed On
                      <span class="table-header-align ml-5 d-flex flex-column">
                        <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags == 'reviewedDate' ? 'link-color' : '']" />

                        <i class="fa fa-angle-down" aria-hidden="true" :class="[headersDscSortFlags == 'reviewedDate' ? 'link-color' : '']" />
                      </span>
                    </span>
                  </th>
                  <th class="heading-color heading-label border-0 w-190">
                    <span class="d-flex align-center cursor_pointer disable-text-selection" @click="sortData('lockedDate')">
                      Locked On
                      <span class="table-header-align ml-5 d-flex flex-column">
                        <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags == 'lockedDate' ? 'link-color' : '']" />
                        <i class="fa fa-angle-down" aria-hidden="true" :class="[headersDscSortFlags == 'lockedDate' ? 'link-color' : '']" />
                      </span>
                    </span>
                  </th>
                  <th class="heading-color heading-label border-0 w-154">
                    <span class="d-flex align-center cursor_pointer disable-text-selection" @click="sortData('milestoneName')">
                      Milestone
                      <span class="table-header-align ml-5 d-flex flex-column">
                        <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags == 'milestoneName' ? 'link-color' : '']" />
                        <i class="fa fa-angle-down" aria-hidden="true" :class="[headersDscSortFlags == 'milestoneName' ? 'link-color' : '']" />
                      </span>
                    </span>
                  </th>
                  <th class="heading-color heading-label border-0 w-190">
                    <span class="d-flex align-center cursor_pointer disable-text-selection" @click="sortData('lastQueryCreated')">
                      Last Query Created
                      <span class="table-header-align ml-5 d-flex flex-column">
                        <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags == 'lastQueryCreated' ? 'link-color' : '']" />
                        <i class="fa fa-angle-down" aria-hidden="true" :class="[headersDscSortFlags == 'lastQueryCreated' ? 'link-color' : '']" />
                      </span>
                    </span>
                  </th>
                  <th class="heading-color heading-label border-0 w-140">
                    <span class="d-flex align-center cursor_pointer disable-text-selection" @click="sortData('noOfOpenQueries')">
                      # Of Open Queries
                      <span class="table-header-align ml-5 d-flex flex-column">
                        <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags == 'noOfOpenQueries' ? 'link-color' : '']" />

                        <i class="fa fa-angle-down" aria-hidden="true" :class="[headersDscSortFlags == 'noOfOpenQueries' ? 'link-color' : '']" />
                      </span>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody v-if="dataDashboardPaginationData.length > 0">
                <tr v-for="(item, index) in dataDashboardPaginationData" :key="index">
                  <td class="table-content-color" v-if="canPiAccess || canCallCenterAccess">
                    {{ item.email }}
                  </td>
                  <td class="table-content-color participant-id">
                    <span>
                      <router-link
                        v-if="!isEligibleForPPR"
                        :to="{
                          name: 'study-participant-details',
                          params: { studyId, participantId: item.participantId }
                        }"
                        :class="!showParticipantId[index] ? 'text-truncate' : ''"
                        >{{ item.participantId }}</router-link
                      >

                      <router-link
                        v-if="isEligibleForPPR"
                        :to="{
                          name: 'participant-profile',
                          params: { studyId, participantId: item.participantId }
                        }"
                        :class="!showParticipantId[index] ? 'text-truncate' : ''"
                        >{{ item.participantId }}</router-link
                      >

                      <u class="ml-7 cursor_pointer" @click="showParticipant(index)">{{ showParticipantId[index] ? "Hide" : "Show" }}</u>
                    </span>
                  </td>
                  <td>{{ getSiteName(item.siteId) }}</td>
                  <td>{{ item.country }}</td>
                  <td class="table-content-color" v-if="checkViewPermissions(item.viewPermissions)">
                    <router-link
                      :class="canStudyManagerAccess && activityListchecking(item.stype) == true ? 'disabledNavigation' : ''"
                      v-if="!isEligibleForPPR && item.formOrUnscheduledId && item.type === 'SCHEDULED'"
                      :to="{
                        name: 'submitted-form',
                        params: {
                          studyId,
                          formId: item.formOrUnscheduledId,
                          milestone: item.milestone,
                          responseId: item.responseId,
                          participantId: item.participantId,
                          milestone: 0
                        }
                      }"
                    >
                      {{ item.formOrUnscheduledName ? item.formOrUnscheduledName.replace(/_/g, " ") : "" }}
                    </router-link>
                    <router-link
                      :class="canStudyManagerAccess && activityListchecking(item.stype) == true ? 'disabledNavigation' : ''"
                      v-if="isEligibleForPPR && item.formOrUnscheduledId && item.type === 'SCHEDULED'"
                      :to="{
                        name: 'submitted-form-new',
                        params: {
                          studyId,
                          formId: item.formOrUnscheduledId,
                          milestone: item.milestone,
                          responseId: item.responseId,
                          participantId: item.participantId,
                          milestone: 0
                        }
                      }"
                    >
                      {{ item.formOrUnscheduledName ? item.formOrUnscheduledName.replace(/_/g, " ") : "" }}
                    </router-link>
                    <router-link
                      :class="canStudyManagerAccess && activityListchecking(item.stype) == true ? 'disabledNavigation' : ''"
                      v-if="!isEligibleForPPR && item.formOrUnscheduledId && item.type === 'UNSCHEDULED'"
                      :to="{
                        name: 'submitted-packets',
                        params: {
                          studyId,
                          packetId: item.formOrUnscheduledId,
                          unscheduledPacketResponseId: item.responseId,
                          participantId: item.participantId,
                          milestone: 0
                        }
                      }"
                    >
                      {{ item.formOrUnscheduledName ? item.formOrUnscheduledName.replace(/_/g, " ") : "" }}
                      (Unscheduled)
                    </router-link>
                    <router-link
                      :class="canStudyManagerAccess && activityListchecking(item.stype) == true ? 'disabledNavigation' : ''"
                      v-if="item.type === null"
                      :to="{
                        name: 'study-participant-activity-response-edit',
                        params: { studyId, participantId: item.participantId },
                        query: {
                          activityId: item.surveyId,
                          completedOn: item.completionTimeUtc,
                          reportedDataTrackerId: item.reportedDataTrackerId,
                          type: 'Survey'
                        }
                      }"
                    >
                      {{ item.formOrUnscheduledName ? item.formOrUnscheduledName.replace(/_/g, " ") : "" }}
                      (Unscheduled)
                    </router-link>
                    <router-link
                      :class="canStudyManagerAccess && activityListchecking(item.stype) == true ? 'disabledNavigation' : ''"
                      v-if="isEligibleForPPR && item.formOrUnscheduledId && item.type === 'UNSCHEDULED'"
                      :to="{
                        name: 'submitted-packets-reskin',
                        params: {
                          studyId,
                          packetId: item.formOrUnscheduledId,
                          unscheduledPacketResponseId: item.responseId,
                          participantId: item.participantId,
                          responseType: item.type,
                          milestone: 0
                        }
                      }"
                    >
                      {{ item.formOrUnscheduledName ? item.formOrUnscheduledName.replace(/_/g, " ") : "" }}
                      (Unscheduled)
                    </router-link>
                  </td>
                  <td class="table-content-color can-view-disabled" v-else>
                    {{ item.formOrUnscheduledName ? item.formOrUnscheduledName.replace(/_/g, " ") : "" }}
                    <span class="ml-10"> <img width="20px" src="static/img/permission-eye.svg" alt v-b-popover.hover="'You do not have the permission to view this activity'" :popover-style="{ background: '#ffffff' }" />̥ </span>
                  </td>
                  <td class="table-content-color">
                    <template v-if="item.approvalStatus === 'APPROVED' && item.approvedDate">
                      {{ new Date(item.approvedDate) | formatUTCDate }}
                    </template>
                  </td>
                  <td class="table-content-color">
                    <template v-if="item.verificationStatus === 'VERIFIED' && item.verifiedDate">
                      {{ new Date(item.verifiedDate) | formatUTCDate }}
                    </template>
                  </td>
                  <td class="table-content-color">
                    <template v-if="item.signoffStatus === 'SIGNEDOFF' && item.signoffDate">
                      {{ new Date(item.signoffDate) | formatUTCDate }}
                    </template>
                  </td>
                  <td class="table-content-color">
                    <template v-if="item.reviewStatus === 'REVIEWED' && item.reviewedDate">
                      {{ new Date(item.reviewedDate) | formatUTCDate }}
                    </template>
                  </td>
                  <td class="table-content-color">
                    <template v-if="item.lockStatus === 'LOCKED' && item.lockedDate">
                      {{ new Date(item.lockedDate) | formatUTCDate }}
                    </template>
                  </td>
                  <td>{{ item.milestoneName }}</td>
                  <td class="table-content-color">
                    <span v-if="item.lastQueryCreated">{{ new Date(item.lastQueryCreated) | formatGMTDate }}</span>
                  </td>
                  <td class="table-content-color">
                    {{ item.noOfOpenQueries }}
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="13" class="empty-text">
                    No records found
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div v-if="dataDashboardPaginationData.length > 0" class="col-sm-12 col-md-12 col-lg-12 col-xs-12 pb-20 pl-0 pr-0">
        <!-- pagination start -->
        <div class="pb-20 pl-15 ml-35 position-absolute bottom-0">
          <div class="row display-inline-flex">
            <div @click="prevPage" class="arrow-icon cursor_pointer" :class="{ disabledPagination: currentPage1 <= 0 }">
              <i class="fa fa-angle-left fs-23"></i>
            </div>
            <div class="pagination pt-3">{{ currentPage1 + 1 }}</div>
            <div class="pagination2 pt-3">of {{ pageCount }}</div>
            <div @click="nextPage" class="arrow-icon cursor_pointer" :class="{ disabledPagination: currentPage1 + 1 == pageCount }">
              <i class="fa fa-angle-right fs-23"></i>
            </div>
          </div>
        </div>
        <!-- pagination end -->
      </div>
    </div>
  </div>
</template>
<script>
import DonutChartWidget from "@/components/widgets/donut-chart-widget";
import { AclRule } from "vue-acl";
import { mapGetters } from "vuex";
import TableComponent from "@/components/common/table";
import { approvalStatusText, verificationStatusText, signoffStatusText } from "@/constants/form";
import { PI, STUDY_MANAGER, CC, STUDY_ADMIN, SYSTEM_ADMIN, HOME_HEALTH, SUB_PI, STUDY_COORDINATOR, SITEDATALOCK, RATER, CRA, CraUB, DM, QUALITY, BIOSTATICS, INTERVIEWER, PHV } from "@/constants/authRoles";
import memoize from "lodash/memoize";
import _ from "lodash";

export default {
  name: "study-participants-data-dashboard",
  components: {
    DonutChartWidget,
    TableComponent
  },
  props: {
    studyId: {
      type: String
    },
    studyData: {
      type: Object,
      default: () => {}
    },
    participantInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      selectedShowOption: 10,
      headersAscSortFlags: "",
      headersDscSortFlags: "",
      currentPage1: 0,
      showTable: false,
      checkedItems: [],
      responseId: null,
      responseVersionId: null,
      isAllSelected: false,
      filterSignoff: null,
      tableValues: [],
      allTableValues: [],
      allSelected: false,
      approvalStatusText,
      verificationStatusText,
      signoffStatusText,
      metainfo: {},
      filterOptions: [
        { value: "APPROVED", text: "Approved" },
        { value: "OPEN", text: "Forms/activities with open queries" },
        { value: "ANSWERED", text: "Forms/activities with answered queries" },
        { value: "CLOSE", text: "Forms/activities with closed queries" },
        { value: "LOCKED", text: "Locked" },
        { value: "REVIEWED", text: "Reviewed" },
        { value: "SIGNEDOFF", text: "Signed Off" },
        { value: "NOT_APPROVED", text: "Unapproved" },
        { value: "UNLOCKED", text: "Unlocked" },
        { value: "UNREVIEWED", text: "Unreviewed" },
        { value: "PENDING", text: "Unsigned Off" },
        { value: "NOT_VERIFIED", text: "Unverified" },
        { value: "VERIFIED", text: "Verified" }
      ],
      perPage: 5,
      totalQueries: 0,
      totalForms: 0,
      isEligibleForPPR: true,
      tableFilter: null,
      showParticipantId: {},
      isDesc: false
    };
  },
  computed: {
    ...mapGetters(["user"]),

    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyManagerAccess() {
      this.$acl.change(`${STUDY_MANAGER}`);
      return this.$acl.check("userAccess");
    },

    pageCount() {
      const l = this.allTableValues.length;

      const s = this.selectedShowOption;
      return Math.ceil(l / s);
    },
    dataDashboardPaginationData() {
      const start = this.currentPage1 * this.selectedShowOption;

      const end = start + this.selectedShowOption;
      return this.allTableValues.slice(start, end);
    },
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    queriesData() {
      return [
        { value: this.metainfo.openQueries, label: "Open", color: "#2E62A1" },
        {
          value: this.metainfo.closedQueries,
          label: "Closed",
          color: "#5BB7CC"
        }
      ];
    },
    verificationData() {
      return [
        {
          value: this.metainfo.unverifiedForms,
          label: "Unverified",
          color: "#DD5B2C"
        },
        {
          value: this.metainfo.verifiedForms,
          label: "Verified",
          color: "#F8CD61"
        }
      ];
    },
    approvalData() {
      return [
        {
          value: this.metainfo.unApprovedForms,
          label: "Unapproved",
          color: "#A73B8F"
        },
        {
          value: this.metainfo.approvedForms,
          label: "Approved",
          color: "#E9668C"
        }
      ];
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canCallCenterAccess() {
      this.$acl.change(`${CC}`);
      return this.$acl.check("userAccess");
    },
    tableFields() {
      let fields = [
        {
          key: "actions",
          label: ""
        },
        {
          key: "participantId",
          label: "Participant Id"
        },
        {
          key: "formName",
          label: "FORM/ACTIVITY NAME"
        },
        {
          key: "lastQueryCreated",
          label: "Last Query Created",
          sortable: true
        },
        {
          key: "noOfOpenQueries",
          label: "# Of Open Queries",
          sortable: true
        },
        {
          key: "approvalStatus",
          label: "Approved On",
          sortable: true
        },
        {
          key: "verificationStatus",
          label: "Verified On",
          sortable: true
        },
        {
          key: "signoffStatus",
          label: "Signed Off On",
          sortable: true
        },
        {
          key: "ReviewStatus",
          label: "Reviewed On",
          sortable: true
        },
        {
          key: "LockedStatus",
          label: "Locked On",
          sortable: true
        }
      ];

      if (this.canPiAccess) {
        fields = [
          fields[0],
          {
            key: "email",
            label: "Email Address"
          },
          ...fields.slice(1)
        ];
      }

      return fields;
    },
    isEmpty: ({ checkedItems }) => checkedItems.length === 0,

    studySites() {
      const sites = {};
      this.studyData.sitesInfo.map(site => {
        sites[site.id] = site.userSiteId;
      });
      return sites;
    }
  },
  watch: {
    allSelected(value) {
      if (value == true) {
        const filtered = this.allTableValues;
        const filterSignoff = filtered.filter(function(value) {
          return value.verificationStatus == "VERIFIED" && value.signoffStatus == "PENDING" && value.approvalStatus == "APPROVED";
        });
        this.checkedItems = filterSignoff;
      } else {
        this.checkedItems = [];
      }
    },
    currentPage1(newPage) {
      this.showParticipantId = {};
      this.currentPageModel = newPage;
    }
  },
  methods: {
    onFilterUpdate(value) {
      this.tableFilter = value;
    },
    activityListchecking(surveyType) {
      if (surveyType && (surveyType == "survey" || surveyType == "epro")) {
        return false;
      } else {
        return true;
      }
    },
    sortDataAsc(data) {
      this.isDesc = false;
      this.headersDscSortFlags = "";
      this.headersAscSortFlags = data;
      this.allTableValues = _.orderBy(this.allTableValues, data, "asc");
    },
    sortDataDsc(data) {
      this.isDesc = true;
      this.headersDscSortFlags = data;
      this.headersAscSortFlags = "";
      this.allTableValues = _.orderBy(this.allTableValues, data, "desc");
    },
    sortData(column) {
      this.showParticipantId = {};
      if (this.headersDscSortFlags != column && this.headersAscSortFlags != column) {
        this.sortDataAsc(column);
        return;
      }

      if (this.isDesc) {
        this.sortDataAsc(column);
      } else {
        this.sortDataDsc(column);
      }
    },
    prevPage() {
      this.currentPage1--;
    },
    nextPage() {
      this.currentPage1++;
    },
    selectoptionChange() {
      this.currentPage1 = 0;
    },
    getFotmattedDate(date) {
      if (date == null) {
        return "";
      } else {
        return new Date(date).toUTCString();
      }
    },
    getRedirectPath(data) {
      if (data.formOrUnscheduledName == "Packet") {
        const params = {
          studyId: this.studyId,
          packetId: data.formOrUnscheduledId,
          unscheduledPacketResponseId: data.responseId,
          participantId: data.participantId
        };
        this.$router.push({ name: "submitted-packets-reskin", params: params });
      }
    },
    gotoParticipantProfile(data) {
      const params = {
        participantId: data.participantId
      };
      this.$router.push({ name: "participant-profile", params: params });
    },
    getFormattedValues(value) {
      if (value == "UNSCHEDULED") {
        return "(Unscheduled)";
      } else if (value == "SCHEDULED") {
        return "(Scheduled)";
      } else if (value == "NOT_VERIFIED") {
        return "Unverified";
      } else if (value == "NOT_APPROVED") {
        return "Unapproved";
      } else if (value == "APPROVED") {
        return "Approved";
      } else if (value == "VERIFIED") {
        return "Verified";
      } else if (value == "PENDING") {
        return "Pending";
      } else if (value == "SIGNEDOFF") {
        return "Signed Off";
      }
    },
    getToggledFeatures() {
      const toggleFeatures = this.$store.getters.getStudyToggledFeatures ? this.$store.getters.getStudyToggledFeatures : JSON.parse(window.localStorage.getItem("toggledFeatures"));
      toggleFeatures.forEach(feature => {
        if (feature.featureKey === "OLDPROFILEVIEW") {
          this.isEligibleForPPR = !feature.enabled;
        }
      });
    },
    async getQueries({ currentPage, sortBy, sortDesc, perPage }) {
      const limit = perPage;
      const offset = limit * (currentPage - 1);
      const { queries } = await this.getCacheStatistic([offset, limit, sortBy, sortDesc]);
      this.allTableValues = queries;
      this.showParticipantId = {};
      return queries;
    },
    printTotalFormatter() {
      return `Total queries: ${this.totalQueries}`;
    },
    async getStatistic(params) {
      try {
        const data2 = await this.$api.dataDashboardTableV2Fetch(this.studyId, params, this.tableFilter);
        const donutData = await this.$api.dashboadMetaData(this.studyId);
        this.metainfo = donutData.body;
        this.metainfo.totalForms = data2.length;
        const data = {
          metainfo: this.metainfo,
          queries: data2
        };
        this.totalQueries = data.metainfo.totalQueries;
        this.totalForms = data.metainfo.totalForms;
        // do not update metainfo if it already exists
        if (!Object.keys(this.metainfo).length) {
          this.metainfo = data.metainfo;
        }
        return data;
      } catch (error) {
        const { message = "Error while statistic request" } = (error && error.body) || {};
        this.$toastr.error(message);
      }
      return null;
    },
    toggleSelected() {
      this.checkedItems = this.tableValues ? [] : this.allSelected;
    },
    isChecked(item) {
      for (let i = 0; i < this.checkedItems.length; i++) {
        if (this.checkedItems[i].participantId == item.participantId) {
          return true;
        }
      }
      return false;
    },

    getSiteName(id) {
      if (!id || id === null) {
        return;
      }

      return Object.keys(this.studySites).length > 0 && !!this.studySites[id] ? this.studySites[id] : "";
    },

    showParticipant(index) {
      if (typeof this.showParticipantId[index] === "undefined" || !this.showParticipantId[index]) {
        this.$set(this.showParticipantId, index, true);
      } else {
        this.$set(this.showParticipantId, index, false);
      }
    },
    checkViewPermissions(viewPermissionsStringOld) {
      let viewPermissionsString = viewPermissionsStringOld;
      let canView = false;
      viewPermissionsString = this.checkForInvalidStrings(viewPermissionsString);

      let currentRole;
      switch (this.userAccess[0][0]) {
        case PI:
          currentRole = "Principal-Investigator";
          break;
        case HOME_HEALTH:
          currentRole = "Home-Health";
          break;
        case SUB_PI:
          currentRole = "Sub-Investigator";
          break;
        case STUDY_COORDINATOR:
          currentRole = "Study-Coordinator";
          break;
        case SITEDATALOCK:
          currentRole = "Site-DataLock";
          break;
        case RATER:
          currentRole = "Rater";
          break;
        case CRA:
          currentRole = "CRA";
          break;
        case CraUB:
          currentRole = "CraUB";
          break;
        case DM:
          currentRole = "Data-Management";
          break;
        case CC:
          currentRole = "Call-Center";
          break;
        case QUALITY:
          currentRole = "Quality";
          break;
        case BIOSTATICS:
          currentRole = "Biostatistics";
          break;
        case INTERVIEWER:
          currentRole = "Interviewer";
          break;
        case PHV:
          currentRole = "Pharmacovigilance";
          break;
      }
      // if these are Admin roles or PI role
      if (this.user && (this.canStudyAdminAccess || this.canSysAdminAccess || this.canStudyManagerAccess)) {
        canView = true;
      } else if (viewPermissionsString && viewPermissionsString.length) {
        const permissionsArr = viewPermissionsString.split(",");
        canView = permissionsArr.some(user => user == currentRole);
      } else {
        canView = true;
      }
      return canView;
    },
    checkForInvalidStrings(value) {
      if (!value) {
        return null;
      } else if (value === "null") {
        return null;
      } else if (value === "undefined") {
        return null;
      } else if (value === "") {
        return null;
      } else {
        return value;
      }
    }
  },
  mounted() {
    this.getToggledFeatures();
  },
  created() {
    this.getCacheStatistic = memoize(([offset, limit, sortBy, sortDesc]) => this.getStatistic({ offset, limit, sortBy, sortDesc }));
  }
};
</script>
<style scoped lang="scss">
@import "~@/assets/variables.scss";
.data-dashboard {
  &.table {
    &::-webkit-scrollbar {
      height: 7px;
    }

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: white;
      box-shadow: white;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #c7d1d5;
      border-radius: 10px;
      outline: none;
    }

    tr {
      &:last-child {
        td {
          border-bottom: 1px solid #dee2e6;
        }
      }
    }
    td {
      padding: 0.5rem 0.5rem;
      line-height: 1.43;
      vertical-align: inherit;
      height: 60px;

      &.participant-id {
        .text-truncate {
          display: inline-block;
          width: 120px;
          vertical-align: bottom;
        }
      }
    }

    .table-header-align {
      i {
        &.fa {
          cursor: pointer;
          line-height: 8px;
        }
      }
    }

    .heading-label {
      font-size: 12px;
      height: 2.86rem;
      vertical-align: middle;
      padding: 0.5rem;
      color: #9b9b9b;
      font-weight: normal;
    }
  }
}
.component {
  background-color: $color_content_background;
}
.APPROVED,
.VERIFIED,
.SIGNEDOFF {
  color: #48bf7a;
}
.NOT_VERIFIED,
.NOT_APPROVED,
.PENDING {
  color: #f16559;
}
.side-margings {
  margin-left: 29px;
  margin-right: 29px;
}
.selectAllCheckbox {
  position: relative;
  left: 2.5rem;
  top: 6.25rem;
  z-index: 1000;
  padding-left: 0;
}
.selectallCheckbox {
  position: relative;
  padding-left: 0;
}
.signOffBtn {
  position: relative;
  left: 60rem;
  top: 4.3rem;
  z-index: 1;
}
@media screen and (max-width: 900px) {
  .signOffBtn {
    position: relative;
    left: 41rem;
    top: 4.3rem;
    z-index: 1;
  }
}
.inside_table_checkbox {
  left: -10px;
  margin-right: 0;
  padding-right: 0;
  padding-left: 0;
}
.inside-table-checkbox {
  margin-right: 0;
  padding-right: 0;
  padding-left: 0;
}
//pagination css
.position-absolute {
  position: absolute;
}
.bottom-0 {
  bottom: 36px;
}
.display-inline-flex {
  display: inline-flex !important;
}
/deep/ .arrow-icon {
  width: 26px;
  height: 27px;
  border-radius: 3px;
  padding: 0px 0px 0px 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 23px;
  line-height: 10px !important;
  color: #e4e8eb;
}
.disabledPagination {
  pointer-events: none;
}
/deep/ .pagination {
  width: 26px;
  height: 27px;
  border-radius: none;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  padding: 0px 0px 0px 10px;
  border: solid 1px #d8d8d8;
  background-color: #ffffff;
  font-size: 13px;
  color: #4a4a4a;
}
/deep/ .pagination2 {
  width: auto;
  min-width: 40px;
  height: 27px;
  background-color: #ffffff;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 6px !important;
}
//table css
.sortDown {
  padding-left: 5px;
  padding-top: 3px;
  cursor: pointer;
  color: #dbdbf5;
}
.sortUp {
  margin-top: 1px;
  padding-left: 13px;
  cursor: pointer;
  color: #dbdbf5;
}
.APPROVED,
.VERIFIED {
  color: #48bf7a !important;
}
.NOT_VERIFIED,
.NOT_APPROVED {
  color: #f16559 !important;
}
.empty-text {
  text-align: center;
}
.link-color {
  color: black !important;
}
.disabledNavigation {
  pointer-events: none !important;
}
.wrapper {
  overflow-x: auto;
  scrollbar-color: #9b9b9b #e5e5e5;
  scrollbar-width: thin;
}
.height-500 {
  min-height: 400px !important;
}
.can-view-disabled {
  color: #007bff;
  cursor: pointer;
}
</style>
